const isMacOS = (): boolean => navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export default isMacOS;
